export const DOCUMENT_TYPE_ARTICLE_LANDING_PAGE = 'articleLandingPage';
